import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { connect } from "react-redux";
import actions from './Redux/Actions/app';
import {Layout} from './Views';
import {Landing} from './Views'
import {BASE_NAME} from './Utilities/constants';
import { ErrorPage } from './Components';
import Step1 from './Views/Step1';
import Step2 from './Views/Step2';
import Step3 from './Views/Step3';
import ThankYou from './Views/ThankYou';
import { BlackBottom } from './Components/Layout';
class App extends Component {
  static propTypes = {
    initialized: PropTypes.bool,
    initializing: PropTypes.bool,
    initialize: PropTypes.func
  };

  componentDidMount(){
    const {initialize} = this.props;
    initialize();
   
  }
/*   render(){
    const {loading, ...props} = this.props;
    return !loading && (<Layout {...props} />);
  } */
  
 
   render() {
     return (<BrowserRouter basename={BASE_NAME}>
         <Layout>
           <Routes >
             <Route path='/' Component={Landing}  />
             <Route path='/step-1' Component={Step1} />
             <Route path='/step-2' Component={Step2} />
             <Route path='/step-3' Component={Step3} />
             <Route path='/thank-you' Component={ThankYou} />
             <Route path={'*'} element={<ErrorPage />} />
           </Routes>
           </Layout>
         </BrowserRouter>
     );
   }
}


const stateToProps = (state) => ({
  ...state.app
});

export {App as _App};
export default connect(stateToProps, actions)(App);
